import { Level } from "./level.js"

export class Outdoor extends Level {
    constructor(key, level, options){
        if (new.target === Outdoor) throw new TypeError("Cannot construct [Outdoor] instances directly")
        super(key, level, {...options, x: 815, y: 640, background: "assets/outdoor/background.jpg", music: "music-outside"});
        this._layout = {
            ...this._layout, outdoor: {
                article: [
                    {
                        "name": "tree-1-1",
                        "positions": {"left": 273, "top": 146},
                    },
                    {
                        "name": "tree-1-2",
                        "positions": {"left": 838, "top": 2025},
                    },
                    {
                        "name": "tree-2-1",
                        "positions": {"left": 1827, "top": 349},
                    },
                    {
                        "name": "tree-2-2",
                        "positions": {"left": 3467, "top": 463},
                    },
                    {
                        "name": "tree-2-3",
                        "positions": {"left": 105, "top": 1458},
                    },
                    {
                        "name": "tree-2-4",
                        "positions": {"left": 2304, "top": 1176},
                    },
                    {
                        "name": "tree-2-5",
                        "positions": {"left": 516, "top": 2386},
                    },
                    {
                        "name": "tree-3-1",
                        "positions": {"left": 2853, "top": 396},
                    },
                    {
                        "name": "tree-3-2",
                        "positions": {"left": 970, "top": 1102},
                    },
                    {
                        "name": "tree-3-3",
                        "positions": {"left": 3532, "top": 1789},
                    },
                    {
                        "name": "tree-3-4",
                        "positions": {"left": 1313, "top": 2315},
                    },
                    {
                        "name": "tree-3-5",
                        "positions": {"left": 2787, "top": 2222},
                    },
                    {
                        "name": "fence-1",
                        "positions": {"left": 492, "top": 415},
                    },
                    {
                        "name": "fence-2",
                        "positions": {"left": 1177, "top": 1278},
                    },
                    {
                        "name": "fence-3",
                        "positions": {"left": 3734, "top": 1357},
                    },
                    {
                        "name": "fence-4",
                        "positions": {"left": 241, "top": 2365},
                    },
                    {
                        "name": "fence-5",
                        "positions": {"left": 3021, "top": 2394},
                    },
                    {
                        "name": "bush-1-1",
                        "positions": {"left": 1316, "top": 442},
                    },
                    {
                        "name": "bush-1-2",
                        "positions": {"left": 2669, "top": 816},
                    },
                    {
                        "name": "bush-2",
                        "positions": {"left": 3043, "top": 1770},
                    },
                    {
                        "name": "bush-3",
                        "positions": {"left": 1758, "top": 1323},
                    },
                    {
                        "name": "house-start",
                        "positions": {"left": 726, "top": 134},
                    },
                    {
                        "name": "house-simple-1",
                        "positions": {"left": 2098, "top": 491},
                    },
                    {
                        "name": "house-simple-2",
                        "positions": {"left": 2176, "top": 2111},
                    },
                    {
                        "name": "house-garage-1",
                        "positions": {"left": 174, "top": 985},
                    },
                    {
                        "name": "house-garage-2",
                        "positions": {"left": 2918, "top": 1063},
                    },
                    {
                        "name": "stand",
                        "positions": {"left": 2047, "top": 1502},
                    },
                ]
            }
        }
    }
    preload(){
        super.preload()
        this.layout.outdoor.article.forEach(a => this.load.image(a.name, `assets/outdoor/article/${a.name}.png`))
    }
    create(){
        super.create()
        let articles = this.physics.add.staticGroup()
        this.layout.outdoor.article.forEach(d => {
            let so = articles.create(d.positions.left, d.positions.top, d.name).setOrigin(0).refreshBody()
            so.setSize(so.body.width, so.body.height - 155, false)
        })
        this.physics.add.collider(this.bob, articles)
    }
}